<template>
  <div class="public-uploader"></div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  MQ_HOST,
  MQ_USERNAME,
  MQ_PASSWORD,
  EXCHANGE_NAME,
  WS_ADDRESS
} from "@/config/setting.js";
import Stomp from "stompjs";
// import VersionServices from '@/services/version.services'

export default {
  name: "PublicUploader",
  async mounted() {
    this.clearURLLIST = setInterval(() => {
      this.CHECK_URLLIST();
    }, 300000);
    this.ws = new WebSocket(WS_ADDRESS);
    // 获得Stomp client对象
    this.client = Stomp.over(this.ws);
    // client.heartbeat.outgoing = ;
    // client.heartbeat.incoming = ;
    this.client.connect(
      MQ_USERNAME,
      MQ_PASSWORD,
      this.onConnect,
      this.onError,
      MQ_HOST
    );
  },
  data() {
    return {
      clearURLLIST: "",
      downurlArr: []
    };
  },
  computed: {
    ...mapGetters("versionmanage", [
      "tableDateList",
      "uploadVersionlist",
      "pageRouter",
      "nowurl"
    ]),
    ...mapGetters("uploader", ["downloadList", "downloadUrllist"])
  },
  watch: {},
  methods: {
    ...mapMutations("versionmanage", [
      "CHECK_TABLETADE",
      "EDIT_VERSIONLIST",
      "DELETE_VERSIONLIST"
    ]),
    ...mapMutations("uploader", ["DELETE_URLLIST", "CHECK_URLLIST"]),
    // ws connect error
    onError(e) {
      console.log("websocket 断开:", e, "this.client.ws:", this.client.ws);
    },
    // 建立链接
    onConnect() {
      const that = this;
      console.log("建立链接");
      // 建立订阅data.body是接收到的数据
      this.client.subscribe(EXCHANGE_NAME, async function(webdata) {
        const { type, data } = JSON.parse(webdata.body);
        console.log(type, data, "33333333333");
        console.log(JSON.parse(data), "222222222");
        console.log(type, JSON.parse(data), "1111111111111111");

        // type=1===》下载日志
        if (type === 1) {
          const { eventId, url } = JSON.parse(data);
          let findindexUrl = that.downloadUrllist.findIndex(item => {
            return item.eventId === eventId;
          });
          if (findindexUrl !== -1) {
            that.DELETE_URLLIST(eventId);
            let down = setInterval(() => {
              that.download(url);
              clearTimeout(down);
            }, 1000);
          }
        }

        // type=2===》版本包上传进度
        if (type === 2) {
          const { id, percent, isAbnormal, isComplete } = JSON.parse(data);
          that.EDIT_VERSIONLIST(JSON.parse(data));
          that.CHECK_TABLETADE(JSON.parse(data));
          if (
            isComplete &&
            percent == 100 &&
            !isAbnormal &&
            that.$route.path === "/version/management"
          ) {
            // 进度完成-刷新页面
            // const { status, result } =await VersionServices.UpdateVersion({
            //   data: that.nowurl
            // });
            // if (status === 0 && that.$route.path == "/version/management") {
            location.reload();
            // }
          }
        }
      });
    },
    // 下载文件
    download(url, fileName) {
      console.log("下载文件", this.downloadUrllist, "this.downloadUrllist");
      let a = document.createElement("a");
      a.style.display = "block";
      fileName ? a.setAttribute("download", fileName) : "";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
  beforeDestroy() {
    clearInterval(this.clearURLLIST);
    this.ws.close();
  },
  components: {}
};
</script>

<style lang="less" scoped></style>
